import { ForbiddenError, UnauthorizedError, isApiError } from '@/lib/api/errors'
import { clearPkceState } from '@/lib/auth/pkce'
import { clearStoredTokens } from '@/lib/auth/tokenStore'

export type AuthErrorResult = 'none' | 'unauthorized' | 'forbidden'

type AuthHandlerOptions = {
  unauthorizedRedirectPath?: string
  redirectOnUnauthorized?: boolean
}

const DEFAULT_OPTIONS: Required<AuthHandlerOptions> = {
  unauthorizedRedirectPath: '/',
  redirectOnUnauthorized: true,
}

function withReturnTo(path: string): string {
  if (typeof window === 'undefined') return path
  const current = `${window.location.pathname}${window.location.search}`
  return `${path}?returnTo=${encodeURIComponent(current)}`
}

export function handleApiAuthError(error: unknown, options?: AuthHandlerOptions): AuthErrorResult {
  if (!isApiError(error)) {
    return 'none'
  }

  const finalOptions = { ...DEFAULT_OPTIONS, ...options }

  if (error instanceof UnauthorizedError) {
    clearStoredTokens()
    clearPkceState()
    if (finalOptions.redirectOnUnauthorized && typeof window !== 'undefined') {
      window.location.assign(withReturnTo(finalOptions.unauthorizedRedirectPath))
    }
    return 'unauthorized'
  }

  if (error instanceof ForbiddenError) {
    return 'forbidden'
  }

  return 'none'
}
